import './App.css';
import availableTable from "./table.svg";
import selectedTableImage from "./table_selected.svg";
import lessSeats from "./table_less_seats.svg";
import unavailableTable from "./table_unavailable.svg";
import headerImage from "./header_image.jpg";
import React, {useState, useRef} from "react";
import tables from './Tables.json';
import axios from 'axios';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import QRCode from "react-qr-code";

function App() {
  const ticketPrice = 250;
  const foundationName = "Fundacja Politechniki Warszawskiej";
  const foundationAccountNumber = "84124060031111001120611736";
  const apiToken = "ersjnf2n3b7fq08z1fwd8o25lleqlc34b7s87p5of9h3nkz1";
  const [closedRegistration, setClosedRegistration] = useState(true);
  const [showMainForm, setShowingMainForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disableRoundOfReservation, setDisableRoundOfReservation] = useState(false);
  const [unavailableTables, setUnavailableTables] = useState([]);
  const [tablesWithLessSeats, setTablesWithLessSeats] = useState([]);
  const [formFinished, setFormFinished]  = useState(false);
  const [numberOfTickets, setNumberOfTickets] = useState(0);
  const [selectedTable, setSelectedTable] = useState(-1);
  const [mainEmail, setMainEmail] = useState("");
  const [mainEmailErrorMode, setMainEmailErrorMode] = useState(0);
  const [mainTelephone, setMainTelephone] = useState("");
  const [mainTelephoneErrorMode, setMainTelephoneErrorMode] = useState(0);
  const [personName, setPersonName] = useState([""]);
  const [personType, setPersonType] = useState([0]);
  const [personNameErrorMode, setPersonNameErrorMode] = useState([0]);
  const [personOrigin, setPersonOrigin] = useState([""]);
  const [personOriginErrorMode, setPersonOriginErrorMode] = useState([0]);
  const [personDiet, setPersonDiet] = useState([0]);
  const [personEmail, setPersonEmail] = useState([""]);
  const [personEmailErrorMode, setPersonEmailErrorMode] = useState([0]);
  const [personConference, setPersonConference] = useState([false]);
  const [rulesAccepted, setRulesAccepted] = useState(false);
  const [rodoAccepted, setRodoAccepted] = useState(false);
  const [reservationNumber, setReservationNumber] = useState(false);
  const tableForm = useRef(null);
  const mainForm = useRef(null);
  const ticketForms = [useRef(null), useRef(null)];

  const LoadingSpinner = () => {
    return (
        <CircleSpinnerOverlay
            loading={isLoading}
            color="#003A39"
            overlayColor="#00003A39"
        />
    );
  }

  const refreshTables = (e) => {
    if(e.target.checked) {
      setIsLoading(true);
      axios
        .get(`https://rdpw.pw.edu.pl/api/gmn/getUnavailableTables.php`, { params: { token: apiToken }})
        .then(function(response) {
          if (!response.data.isEmpty && response.data[0] === -1) {
            setDisableRoundOfReservation(true);
          } else {
            setUnavailableTables(response.data);
          }
          axios
            .get(`https://rdpw.pw.edu.pl/api/gmn/getTablesWithLessSeats.php`, { params: { tickets: e.target.value, token: apiToken }})
            .then(function(response) {
              setTablesWithLessSeats(response.data);
              setIsLoading(false);
              setSelectedTable(-1);
              let emptyStringArray = [];
              let emptyIntArray = [];
              let emptyBoolArray = [];
              for (let i = 0; i < e.target.value; i++) {
                emptyStringArray.push("");
                emptyIntArray.push(0);
                emptyBoolArray.push(false);
              }
              setPersonName(emptyStringArray);
              setPersonType(emptyIntArray);
              setPersonOrigin(emptyStringArray);
              setPersonDiet(emptyIntArray);
              setPersonEmail(emptyStringArray);
              setPersonNameErrorMode(emptyIntArray);
              setPersonOriginErrorMode(emptyIntArray);
              setPersonEmailErrorMode(emptyIntArray);
              setPersonConference(emptyBoolArray);
              setNumberOfTickets(parseInt(e.target.value));
              setShowingMainForm(true);
            });
        });
    }
  }

  const updateNameField = index => e => {
    let newArr = [...personName];
    newArr[index] = e.target.value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,"");
    setPersonName(newArr);
  }

  const updateTypeField = index => e => {
    let newArr = [...personType];
    newArr[index] = parseInt(e.target.value);
    setPersonType(newArr);
  }

  const updateOriginField = index => e => {
    let newArr = [...personOrigin];
    newArr[index] = e.target.value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,"");
    setPersonOrigin(newArr);
  }

  const updateDietField = index => e => {
    let newArr = [...personDiet];
    newArr[index] = parseInt(e.target.value);
    setPersonDiet(newArr);
  }

  const updateEmailField = index => e => {
    let newArr = [...personEmail];
    newArr[index] = e.target.value.trim();
    setPersonEmail(newArr);
  }

  const updateConferenceField = index => e => {
    let newArr = [...personConference];
    newArr[index] = e.target.checked;
    setPersonConference(newArr);
  }

  const handleClickReserve = () => {
    if (validateForm()) {
      const jsonData = JSON.stringify(generateJSONForm(), null, 2);
      setIsLoading(true);
      axios.post('https://rdpw.pw.edu.pl/api/gmn/createReservation.php', jsonData)
        .then((response) => {
          setIsLoading(false);
          let returnInfo = response.data;
          if (Number.isInteger(returnInfo)) {
            setReservationNumber(returnInfo);
            setFormFinished(true);
          } else {
            alert(returnInfo);
          }
        }, (error) => {
          setIsLoading(false);
        });
    }
  };

  const validateForm = () => {
    var status;
    var scrolled = false;
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    status = selectedTable !== -1;
    if (!status && !scrolled) {
      tableForm.current.scrollIntoView()
      scrolled = true;
    }
    const mainEmailMode = mainEmail === "" ? 1 : mainEmail.match(validRegex) ? 0 : 2;
    setMainEmailErrorMode(mainEmailMode);
    const mainTelephoneMode = mainTelephone === "" ? 1 : mainTelephone.match(/^[0-9\+]{9,14}$/) ? 0 : 2;
    setMainTelephoneErrorMode(mainTelephoneMode);
    status = status && mainEmailMode === 0 && mainTelephoneMode === 0;
    const nameErrorMode = [];
    const originErrorMode = [];
    const emailErrorMode = [];
    if (!status && !scrolled) {
      mainForm.current.scrollIntoView()
      scrolled = true;
    }
    for (let i = 0; i < numberOfTickets; i++) {
      const personNameMode = personName[i] !== "" ? 0 : 1;
      nameErrorMode.push(personNameMode);
      const personOriginMode = personType[i] !== 3 ? personOrigin[i] !== "" ? 0 : 1 : 0;
      originErrorMode.push(personOriginMode);
      const personEmailMode = personEmail[i] !== "" && personEmail[i].match(validRegex) ? 0 : personEmail[i] === "" ? 0 : 1;
      emailErrorMode.push(personEmailMode);
      status = status && personNameMode === 0 && personOriginMode === 0 && personEmailMode === 0;
      if (!status && !scrolled) {
        ticketForms[i].current.scrollIntoView()
        scrolled = true;
      }
    }
    setPersonNameErrorMode(nameErrorMode);
    setPersonOriginErrorMode(originErrorMode);
    setPersonEmailErrorMode(emailErrorMode);
    return status;
  };

  const generateJSONForm = () => {
    const peopleVariable = [];
    for (let i = 0; i < numberOfTickets; i++) {
      if (personEmail[i] !== "") {
        peopleVariable.push({name: personName[i].trim(), type: personType[i], origin: personOrigin[i].trim(), diet: personDiet[i], email: personEmail[i], conference: personConference[i]});
      } else {
        peopleVariable.push({name: personName[i].trim(), type: personType[i], origin: personOrigin[i].trim(), diet: personDiet[i], conference: personConference[i]});
      }
    }
    return {basic_data: { token: apiToken, table_id: selectedTable, table_name: tables.find(value => value.id === selectedTable).name, main_name: personName[0], main_email: mainEmail, main_telephone: mainTelephone, ticket_price: ticketPrice }, people : peopleVariable};
  };

  const sectionGenerator = (section) => {
    return tables.filter(e => e.section === section).map((number) => {
      return (
        <x><Button id={number.id} name={number.name} margin={number.margin} available={number.available}/>{number.nextLine ? <br/> : ""}</x>
      );
    })
  }

  const Button = ({ id, name, margin, available }) => {
    return (
        <x>
          <button className={(!available || unavailableTables.find(e => e === id)) ? "tableButtonUnavailable" : tablesWithLessSeats.find(e => e === id) ? "tableButtonLessSeats" : (selectedTable === id) ? "tableButtonSelected" : "tableButton"} style={{ "margin-left": margin }} type="button" onClick={(e) => setSelectedTable(id) } disabled={!available || unavailableTables.find(e => e === id)}>{name}</button>
        </x>
    );
  };

  const qrCodeValue = (price, title) => {
    return "|PL|"+foundationAccountNumber+"|"+price+"00|"+foundationName+"|"+title+"|||"
  }

  const ticketFormGeneration = (number) => {
    return (
        <x>
          <div className="formSection">
            <div className="formPL">Bilet nr {number}</div>
            <div className="formEN">Ticket no. {number}</div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Imię i nazwisko*</div>
                <div align="left" className="formEN">Firstname & lastname*</div>
              </div>
              <div className={personNameErrorMode[number-1] !== 0 ? "group error" : "group"}>
                <input type="text" value={personName[number-1]} onChange={updateNameField(number-1)}/>
              </div>
              {personNameErrorMode[number-1] === 1 ? <div className="group errorLabel">Wprowadź imię i nazwisko</div> : ""}
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Rodzaj biletu</div>
                <div align="left" className="formEN">Type of ticket</div>
              </div>
              <div className="group">
                <label className="container"><div align="left" className="formPL">Student</div><div align="left" className="formEN">Student</div><input type="radio" name={number+"-type"} value="0" className="checkbox" defaultChecked onChange={updateTypeField(number-1)}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Doktorant</div><div align="left" className="formEN">PhD Candidate </div><input type="radio" name={number+"-type"} value="1" className="checkbox" onChange={updateTypeField(number-1)}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Asystent/Adiunkt</div><div align="left" className="formEN">Teaching Assistant/Assistant Professor</div><input type="radio" name={number+"-type"} value="2" className="checkbox" onChange={updateTypeField(number-1)}/><span
                    className="radio"></span></label>
                {number !== 1 ? <label className="container"><div align="left" className="formPL">Osoba towarzysząca</div><div align="left" className="formEN">Accompanying person</div><input type="radio" name={number+"-type"} value="3" className="checkbox" onChange={updateTypeField(number-1)}/><span
                    className="radio"></span></label> : "" }
              </div>
            </div>
            {personType[number-1] !== 3 ? <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Koło Naukowe/Szkoła Doktorska/Wydział*</div>
                <div align="left" className="formEN">Science Club/Doctoral School/Faculty*</div>
              </div>
              <div className={personOriginErrorMode[number-1] !== 0 ? "group error" : "group"}>
                <input type="text" value={personOrigin[number-1]} onChange={updateOriginField(number-1)}/>
              </div>
              {personOriginErrorMode[number-1] === 1 ? <div className="group errorLabel">Wprowadź informację skąd jest osoba</div> : ""}
            </div> : "" }
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Dieta</div>
                <div align="left" className="formEN">Diet</div>
              </div>
              <div className="group">
                <label className="container"><div align="left" className="formPL">Klasyczna</div><div align="left" className="formEN">Classic</div><input type="radio" name={number+"-food"} value="0" className="checkbox" defaultChecked onChange={updateDietField(number-1)}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Wegetariańska</div><div align="left" className="formEN">Vegetarian</div><input type="radio" name={number+"-food"} value="1" className="checkbox" onChange={updateDietField(number-1)}/><span
                    className="radio"></span></label>
              </div>
            </div>
            {(number + 1) <= numberOfTickets ? <div ref={ticketForms[number]}></div> : "" }
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">E-mail</div>
                <div align="left" className="formEN">E-mail</div>
              </div>
              <div className={personEmailErrorMode[number-1] !== 0 ? "group error" : "group"}>
                <input type="text" value={personEmail[number-1]} onChange={updateEmailField(number-1)}/>
              </div>
              {personEmailErrorMode[number-1] === 1 ? <div className="group errorLabel">Niepoprawny format e-maila</div> : ""}
            </div>
          </div>
          <label className="container"><div align="left" className="formPL">Chcę również wziąć udział w konferencji</div><div align="left" className="formEN">I also want to take part in conference</div><input type="checkbox" name="food" className="checkbox" onChange={updateConferenceField(number-1)}/><span className="checkmark"></span></label>
          <hr className="rounded"/>
        </x>
    );
  }

  const mainDataFormGeneration = () => {
    return (
        <x>
          <div className="formSection">
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">E-mail osoby dokonującej zapisów*</div>
                <div align="left" className="formEN">E-mail of the main person making reservation*</div>
              </div>
              <div className={mainEmailErrorMode !== 0 ? "group error" : "group"}>
                <input type="text" value={mainEmail} onChange={e => setMainEmail(e.target.value.trim())}/>
              </div>
              {mainEmailErrorMode === 1 ? <div className="group errorLabel">Wprowadź e-mail</div> : mainEmailErrorMode === 2 ? <div className="group errorLabel">Niepoprawny format e-maila</div> : ""}
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Nr telefonu osoby dokonującej zapisów*</div>
                <div align="left" className="formEN">Telephone no. of the main person making reservation*</div>
              </div>
              <div className={mainTelephoneErrorMode !== 0 ? "group error" : "group"}>
                <input type="text" value={mainTelephone} onChange={e => setMainTelephone(e.target.value.trim().replace( /\s|-/g, "" ))}/>
              </div>
              {mainTelephoneErrorMode === 1 ? <div className="group errorLabel">Wprowadź numer telefonu</div> : mainTelephoneErrorMode === 2 ? <div className="group errorLabel">Niepoprawny format telefonu</div> : ""}
            </div>
          </div>
          <hr className="rounded"/>
        </x>
    );
  }

  const termsFormGeneration = () => {
    return (
        <x>
          <div className="formSection">
            <div align="left">
              <label className="container"><div align="left" className="formPL">Akceptuję regulamin Wydarzenia oraz Rejestracji na Bal*</div><div align="left" className="formEN">Accepting the terms and conditions of the Event and Ball Registration*</div><input type="checkbox" value={rulesAccepted} onChange={e => setRulesAccepted(e.target.checked)} className="checkbox"/><span
                  className="checkmark"></span></label>   <a className="appLink" href="https://rdpw.pw.edu.pl/BAL_regulamin_rejestracji_i_wydarzenia.pdf" target="_blank" rel="noopener noreferrer">Link</a><br/>
              <label className="container"><div align="left" className="formPL">Wyrażam zgodę na przetwarzanie moich danych osobowych przez Radę Doktorantów Politechniki Warszawskiej w celu przeprowadzenia procesu rezerwacji, zakupu i weryfikacji biletów na Galę Młodych Naukowców.  Administratorem danych osobowych jest Rada Doktorantów Politechniki Warszawskiej (bmn.rdpw@pw.edu.pl)*</div><div align="left" className="formEN">I consent to the processing of my personal data by the Council of Doctoral Students of Warsaw University of Technology for the purpose of booking, purchasing and verifying tickets for the Young Scientists Gala.  The administrator of the personal data is the Council of Doctoral Students of Warsaw University of Technology (bmn.rdpw@pw.edu.pl)*</div><input type="checkbox" value={rodoAccepted} onChange={e => setRodoAccepted(e.target.checked)} className="checkbox"/><span className="checkmark"></span></label>
            </div>
          </div>
          <hr className="rounded"/>
        </x>
    );
  }

  const requiredFieldsGeneration = () => {
    return (
        <x>
          <div>
            <div className="formPL">*pola obowiązkowe</div><div className="formEN">*required fields</div>
          </div>
        </x>
    );
  }

  const disabledRoundSectionGeneration = () => {
    return (
        <x>
          <content>
            <div className="groupWithoutMargin">
              <div className="formPL">Obecna tura sprzedaży biletów została zakończona, zapraszamy na kolejną w najbliższym czasie!</div>
              <div className="formEN">The current round of ticket sales is over, please join us for the next round in the near future!</div>
            </div>
          </content>
        </x>
    );
  }

  const mainFormGeneration = () => {
    return (
      <x>
        <div>
          <div className="groupWithoutMargin">
            <div align="left" className="formPL">Liczba biletów do zakupu</div>
            <div align="left" className="formEN">Number of tickets</div>
          </div>
          <div className="group">
            <label className="container"><div align="left" className="formPL">1</div><input type="radio" name="ticketValue" className="checkbox" value="1" disabled={isLoading} onChange={refreshTables}/><span
                className="radio"></span></label>
            <label className="container"><div align="left" className="formPL">2</div><input type="radio" name="ticketValue" className="checkbox" value="2" disabled={isLoading} onChange={refreshTables}/><span
                className="radio"></span></label>
          </div>
        </div>
          <content>
            {isLoading ? <LoadingSpinner /> : ""}
            {showMainForm && (<hr className="rounded"/>)}
            {showMainForm && <div className="formPL">Wybierz stolik, przy którym chcesz siedzieć</div>}
            {showMainForm && <div className="formEN" style={{ "margin-bottom": "-35px" }}>Select a table, where you want to sit</div>}
            {showMainForm && (<div align="left" className="tableSelector">
              <div className="sectionOne">{sectionGenerator(1)}</div>
              <div className="sectionThree">{sectionGenerator(3)}</div>
              <div className="sectionTwo">{sectionGenerator(2)}</div>
              <div ref={mainForm}></div>
              <div className="sectionFour">{sectionGenerator(4)}</div>
            </div>)}
            <div ref={ticketForms[0]}></div>
            {showMainForm && (<div>
              <div className="groupWithoutMargin">
                <div>
                  <img src={availableTable} width="50px" alt=""/>
                  <div className="group">
                    <div align="left" className="formPL">Stoliki z dostępną wybraną ilością miejsc</div>
                    <div align="left" className="formEN">Tables with selected number of available seats</div>
                  </div>
                </div>
              </div>
              <div className="group">
                <div>
                  <img src={selectedTableImage} width="50px" alt=""/>
                  <div className="group">
                    <div align="left" className="formPL">Wybrany stolik</div>
                    <div align="left" className="formEN">Selected table</div>
                  </div>
                </div>
              </div>
              <div className="group">
                <div>
                  <img src={lessSeats} width="50px" alt=""/>
                  <div className="group">
                    <div align="left" className="formPL">Stolik z dostępną mniejsza liczbą miejsc</div>
                    <div align="left" className="formEN">Table with less amount of seats</div>
                  </div>
                </div>
              </div>
              <div className="group">
                <div>
                  <img src={unavailableTable} width="50px" alt=""/>
                  <div className="group">
                    <div align="left" className="formPL">Stolik niedostępny</div>
                    <div align="left" className="formEN">Unavailable table</div>
                  </div>
                </div>
              </div>
            </div>)}
            {showMainForm && (<hr className="rounded"/>)}
            {showMainForm && mainDataFormGeneration()}
            {showMainForm && ticketFormGeneration(1)}
            {numberOfTickets === 2 && showMainForm && ticketFormGeneration(2)}
            {showMainForm && termsFormGeneration()}
            {showMainForm && requiredFieldsGeneration()}
            {showMainForm && (<div><input type="button" className="button" value="Rezerwuję!" disabled={isLoading || !rulesAccepted || !rodoAccepted} onClick={handleClickReserve}/></div>)}
            {showMainForm && (<br/>)}
          </content>
      </x>
    );
  }

  const finishFormGeneration = () => {
    return (
          <content>
            <hr className="rounded"/>
            <div className="formSection">
              <div>
                <div className="column75">
                  <div>
                    <div align="left" className="formPLBold">Podsumowanie rezerwacji nr {reservationNumber}</div>
                    <div align="left" className="formENBold">Reservation number {reservationNumber} confirmation</div>
                  </div><br/>
                  <div>
                    <div align="left" className="formPL">Dziękujęmy za rezerwację {numberOfTickets} biletu/-ów o łącznej cenie {numberOfTickets*ticketPrice} zł.</div>
                    <div align="left" className="formEN">Thank you for reservation of {numberOfTickets} ticket(s) with total price {numberOfTickets*ticketPrice} zł.</div>
                  </div><br/>
                  <div>
                    <div align="left" className="formPL">Dane do przelewu</div>
                    <div align="left" className="formEN">Transfer info data</div>
                  </div>
                  <div>
                    <div align="left" className="formPL">Nazwa <i>(name)</i>: {foundationName}</div>
                    <div align="left" className="formPL">Numer konta <i>(account number)</i>: {foundationAccountNumber}</div>
                    <div align="left" className="formPL">Tytuł przelewu <i>(title of transfer)</i>: {personName[0]} rezerwacja biletów numer {reservationNumber}</div>
                  </div>
                </div>
                <div className="column25">
                  <div align="center">
                    <QRCode
                        size={250}
                        style={{ height: "auto", maxWidth: "70%", width: "70%" }}
                        value={qrCodeValue(numberOfTickets*ticketPrice, personName[0]+" rezerwacja biletów numer "+reservationNumber)}
                        viewBox={`0 0 250 250`}
                        align="cemter"
                    />
                  </div>
                  <div align="center" className="formPL">Zeskanuj i zapłać</div>
                  <div align="center" className="formEN">Scan and pay</div>
                  <br/>
                </div>
              </div>
              <br/>
              <div>
                <div align="left" className="formPL">Podsumowanie nie jest potwierdzeniem rezerwacji. Aby potwierdzić rezerwację dokonaj wpłaty za wybraną liczbę biletów. Jeśli nie dostałeś/-aś potwierdzenia rezerwacji na adres e-mail podany w rezerwacji sprawdź folder SPAM. Jeśli w ciągu doby nie dostaniesz potwierdzenia rezerwacji napisz do nas na adres e-mail: <a href='mailto:bmn.rdpw@pw.edu.pl'><i>bmn.rdpw@pw.edu.pl</i></a></div>
                <div align="left" className="formEN">The summary is not a confirmation of the reservation. To confirm your reservation, make a payment for the selected number of tickets. If you did not receive a booking confirmation to the email address provided in the booking, check your SPAM folder. If you do not receive a booking confirmation within 24 hours, write to us at the email address: <a href='mailto:bmn.rdpw@pw.edu.pl'><i>bmn.rdpw@pw.edu.pl</i></a></div>
              </div>
            </div>
            <hr className="rounded"/>
          </content>
    );
  }

  const closedRegistrationForm = () => {
    return (
        <content>
          <hr className="rounded"/>
          <div className="closedForm">
            <div>
              <div align="center" className="formPLBold">Rezerwacja zamknięta</div>
              <div align="center" className="formENBold">Closed reservation</div>
            </div><br/>
            <div>
              <div align="center" className="formPL">Dziękujęmy za zainteresowanie 1. Galą Młodych Naukowców. Niestety rezerwacja została już zamknięta. Jeśli jednak chcesz się spotkać z nami na Balu zachęcamy do kontaktu emailowego w celu omówienia ewentualnego zakupu biletów: bmn.rdpw@pw.edu.pl</div>
              <div align="center" className="formEN">Thank you for your interest in the 1st Young Scientists Gala. Unfortunately, reservations have already been closed. However, if you would like to meet us at the Ball, we encourage you to contact us by email to discuss the possible purchase of tickets: bmn.rdpw@pw.edu.pl</div>
            </div>
          </div>
          <hr className="rounded"/>
        </content>
    );
  }

  return (
      <x>
        <body>
          <header>
            <img className="imageHeader" src={headerImage} />
          </header><br/>
          <div style={{ "height": "50px" }}/>
          <h1 className="groupWithoutMargin">
            <div align="center" className="formPL">Rezerwacja biletów na Bal</div>
            <div ref={tableForm}></div>
            <div align="center" className="formEN" style={{ "margin-bottom": "-20px" }}>Ball ticket reservation</div>
          </h1>
          {closedRegistration ? closedRegistrationForm() : "" }
          {!closedRegistration && disableRoundOfReservation ? disabledRoundSectionGeneration() : ""}
          {!closedRegistration && !disableRoundOfReservation ? formFinished ? finishFormGeneration() : mainFormGeneration() : "" }
          {!closedRegistration && !disableRoundOfReservation ? formFinished ? <div style={{ "height": "55px" }}/> : "" : <div style={{ "height": "55px" }}/> }
          <footer>
            <p className="footerTextLarge">KONTAKT</p>
            <p className="footerTextSmall">Gala Młodych Naukowców Politechniki Warszawskiej<br/>Rada Doktorantów Politechniki Warszawskiej</p>
            <p className="footerTextSmall">bmn.rdpw@pw.edu.pl</p>
            <hr className="footerRoundedSeparator"/>
            <p className="footerTextSmall">Developed by Mikołaj Płachta</p>
          </footer>
        </body>
      </x>
  );
}

export default App;
